import * as React from 'react'
import styled from 'styled-components'
import CheckRadio from 'theme/atoms/CheckRadio'
import theme from 'theme'

type Props = {
  label: string
  options: string[]
  type: 'radio' | 'checkbox'
  radiogroup?: string
  required?: boolean
  allRequired?: boolean
  name?: string
  'data-cy-handle'?: string
  isChecked?: (checked: boolean) => void
}

export default function CheckRadioGroup(props: Props) {
  const checkboxRef = React.useRef<HTMLInputElement>(null)
  const [isChecked, setIsChecked] = React.useState<boolean[]>([])

  React.useEffect(() => {
    const check = Array(props.options.length).fill(false)
    setIsChecked(check)
  }, [])

  const checkController = (i) => {
    const check = isChecked
    check[i] = !check[i]
    setIsChecked(check)
    props.required && props.isChecked && isChecked.includes(true)
      ? props.isChecked(true)
      : props.isChecked && props.isChecked(false)
  }

  return (
    <Wrapper ref={checkboxRef} className="CheckRadioGroup">
      {props.label && (
        <label className="title" data-cy-state>
          {props.label}
        </label>
      )}
      {props.options.map((option, i) => (
        <div key={option} className="checkRadioOption">
          {props.type == 'checkbox' && (
            // eslint-disable-next-line @kaminrunde/firescout/jsx-expression-needs-state
            <CheckRadio
              data-cy-handle={props['data-cy-handle']}
              variation={'checkbox'}
              label={option}
              radiogroup={props.radiogroup}
              required={props.allRequired || props.required}
              onClick={() => {
                checkboxRef.current?.classList.remove('error')
                checkController(i)
              }}
            />
          )}
          {props.type == 'radio' && (
            // eslint-disable-next-line @kaminrunde/firescout/jsx-expression-needs-state
            <CheckRadio
              data-cy-handle={props['data-cy-handle']}
              variation={'radio'}
              label={option}
              required={props.required}
              radiogroup={props.radiogroup || props.label}
              onClick={() => {
                checkboxRef.current?.classList.remove('error')
              }}
            />
          )}
        </div>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > label {
    display: block;
    margin-bottom: ${theme.spacing('xxs')};
    ${theme.ty('r-base')}
  }
  > .checkRadioOption {
    margin-bottom: 0.5rem;
  }
`
